import { GET_PRODUCTS, PRODUCTS_ERROR } from "../types";

const initialState = {
  products: [],
  loading: true,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_PRODUCTS:
      return {
        ...state,
        products: action.payload,
        loading: false,
        error: false,
      };
    case PRODUCTS_ERROR:
      return {
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
